<script setup lang="ts">
import type { NuxtError } from "#app";
definePageMeta({
  allowAnonymous: true,
});
const props = defineProps<{ error: NuxtError }>();

const { t } = useI18n();
const router = useRouter();
const { rootRoute } = useRouteGuard();

const friendlyData = computed(() =>
  props.error?.data && props.error.cause instanceof $ck.utils.PageFriendlyError ? props.error.cause.data : undefined,
);

function handleAction() {
  if (friendlyData.value?.redirect) {
    clearError({
      redirect: $ck.utils.unwrapGetter(friendlyData.value.redirect),
    });
    return;
  }

  if (window.history.state.back === null) {
    clearError({ redirect: rootRoute.value });
  } else {
    clearError();
    router.back();
  }
}
/**
 * Fix for related issue: https://github.com/nuxt/nuxt/issues/34579
 */
setTimeout(() => {
  const activeHead = useHead({
    title: props.error.statusText
      ? t(props.error.statusText)
      : `${props.error?.status}  -  ${t("errors.pages.404.title")}`,
  });

  const head = useLocaleHead({ dir: true, seo: true, lang: true });
  activeHead.patch({
    htmlAttrs: {
      lang: head.value.htmlAttrs?.lang ?? "en",
      dir: <"ltr" | "rtl">head.value.htmlAttrs?.dir ?? "ltr",
      style: `--direction: ${head.value.htmlAttrs?.dir ?? "ltr"};`,
    },
    title: `${props.error?.status}  -  ${t("errors.pages.404.title")}`,
  });
}, 0);
</script>

<template>
  <NuxtLayout name="error">
    <error-card @back="handleAction">
      <template v-if="friendlyData?.heading" #heading>
        {{ $t(friendlyData.heading) }}
      </template>
      <template v-if="friendlyData?.subHeading" #subHeading>
        {{ $t(friendlyData.subHeading) }}
      </template>
      <template v-if="friendlyData?.message" #description>
        {{ $t(friendlyData.message) }}
      </template>
      <template v-if="friendlyData?.actionText" #actionText>
        {{ $t($ck.utils.unwrapGetter(friendlyData.actionText)) }}
      </template>
      <slot />
    </error-card>
  </NuxtLayout>
</template>
